import { render, staticRenderFns } from "./DialogChangePassword.vue?vue&type=template&id=f41b63fe"
import script from "./DialogChangePassword.vue?vue&type=script&lang=js"
export * from "./DialogChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports